import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import BrandedButtonWithContextMenu from '@wix/da-shared-react/pkg/Dropdown/Preset/BrandedButtonWithContextMenu';
import MediaSelector from '@wix/da-shared-react/pkg/MediaPopup/MediaSelector';
import { showSubmitModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';

interface Props {}

const SubmitButton: React.FC<Props> = () => {
  const { t } = useTranslation();
  const [isMediaSelectorOpen, setIsMediaSelectorOpen] = useState(false);
  const dispatch = useDispatch();

  const selectDeviation = () => {
    setIsMediaSelectorOpen(true);
  };

  const closeMediaSelector = () => {
    setIsMediaSelectorOpen(false);
  };

  const submitStatusUpdate = () => {
    dispatch(
      showSubmitModal(ModalType.STATUS_UPDATE, {
        params: { refreshAfterSubmit: true },
      })
    );
  };

  const items = [
    { label: t('groups.submit.submitNewDeviation'), link: URLS.SUBMIT },
    {
      label: t('groups.submit.addExistingDeviation'),
      onClick: selectDeviation,
    },
    { label: t('groups.submit.writePost'), onClick: submitStatusUpdate },
  ];
  return (
    <>
      <BrandedButtonWithContextMenu
        icon={AddIcon}
        items={items}
        size="large"
        variant="brand-green"
      >
        {t('common.submit')}
      </BrandedButtonWithContextMenu>
      {isMediaSelectorOpen && (
        <MediaSelector
          onClose={closeMediaSelector}
          onSelect={closeMediaSelector}
        />
      )}
    </>
  );
};
SubmitButton.displayName = 'SubmitButton';

export default SubmitButton;
